import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LucideAngularModule, Star, ChartBar, Calendar, RefreshCw, LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import type { RegulatoryUpdate } from '@core/models';
import { formatDate, getCardImage, impactChipClass } from '@shared/utils/utils';
import { ButtonComponent } from '../ui/button/button.component';
import { JurisdictionFlagComponent } from '../jurisdiction-flag/jurisdiction-flag.component';

@Component({
  selector: 'app-regulatory-update-card',
  imports: [LucideAngularModule, ButtonComponent, JurisdictionFlagComponent],
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider({ Star, ChartBar, Calendar, RefreshCw }) }],
  templateUrl: './regulatory-update-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegulatoryUpdateCardComponent {
  update = input.required<RegulatoryUpdate>();
  viewMode = input<'grid' | 'list'>('grid');

  viewDetails = output<RegulatoryUpdate>();
  toggleFavourite = output<string>();

  protected readonly cardImage = computed(() => getCardImage(null, this.update().jurisdiction));

  protected readonly pubDate = computed(() => formatDate(this.update().publicationDate));

  protected readonly updatedDate = computed(() => {
    const d = this.update().updatedAt;
    return d ? formatDate(d) : null;
  });

  protected readonly summary = computed(() => {
    const s = this.update().summary;
    return s.length > 150 ? s.slice(0, 150) + '…' : s;
  });

  protected readonly impactBadgeClass = computed(() => impactChipClass(this.update().impactLevel));
}
